import {
    ShopOutlined,
    HomeOutlined,
    CoffeeOutlined,
    MedicineBoxOutlined,
    CarOutlined,
    EnvironmentOutlined,
    AppstoreOutlined,
    SmileOutlined,
    GoldOutlined,
    FireOutlined,
    ExperimentOutlined,
    VideoCameraOutlined,
    BookOutlined,
    QuestionCircleOutlined,
    LaptopOutlined
} from '@ant-design/icons';
import {Tag} from 'antd';

const companyTypeMap = {
    'Оптовый склад': {icon: <AppstoreOutlined/>, color: 'geekblue'},
    'Одежда магазин': {icon: <ShopOutlined/>, color: 'magenta'},
    'Парк развлечений': {icon: <SmileOutlined/>, color: 'purple'},
    'Ювелирный магазин': {icon: <GoldOutlined/>, color: 'gold'},
    'АЗС/ГЭС/ЭЭС': {icon: <FireOutlined/>, color: 'volcano'},
    'Парковка': {icon: <EnvironmentOutlined/>, color: 'blue'},
    'Гостиница': {icon: <HomeOutlined/>, color: 'cyan'},
    'Канцтовары': {icon: <BookOutlined/>, color: 'lime'},
    'IT компания': {icon: <LaptopOutlined/>, color: 'cyan'},
    'Кинотеатр': {icon: <VideoCameraOutlined/>, color: 'orange'},
    'Кондитерская': {icon: <CoffeeOutlined/>, color: 'pink'},
    'Автосалон': {icon: <CarOutlined/>, color: 'red'},
    'Лаборатория': {icon: <ExperimentOutlined/>, color: 'blue'},
    'Кафе': {icon: <CoffeeOutlined/>, color: 'green'},
    'Магазин': {icon: <ShopOutlined/>, color: 'green'},
    'Клиника': {icon: <MedicineBoxOutlined/>, color: 'cyan'},
    'Аптека': {icon: <MedicineBoxOutlined/>, color: 'green'},
};

export const renderCompanyTypeTag = (type, sizeFont = 12) => {
    const typeName = typeof type === 'string' ? type : type?.name;

    const config = companyTypeMap[typeName];
    if (!config) {
        return (
            <Tag icon={<QuestionCircleOutlined/>} color="#55acee" style={{fontSize: sizeFont}}>
                {typeName}
            </Tag>
        );
    }

    return (
        <Tag icon={config.icon} color={config.color} style={{fontSize: sizeFont}}>
            {typeName}
        </Tag>
    );
};

export const companyTypeFilters = Object.keys(companyTypeMap).map((typeName) => ({
    text: renderCompanyTypeTag(typeName),
    value: typeName,
}));